<template>
    <div class="min-h-screen bg-secondary flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div class="sm:mx-auto sm:w-full sm:max-w-md">
            <div class="flex justify-center">
                <svg class="h-16 text-white" aria-hidden="true" focusable="false" role="img" preserveAspectRatio="xMinYMid meet">
                    <use href="/media/sprite.svg#brand-1260"></use>
                </svg>
            </div>
        </div>

        <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
            <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">

                <slot />

            </div>
        </div>
    </div>
</template>

<script>
    export default {
    }
</script>
